import user from './user';
import sidebar from './sidebar';

const ACTIONS = {
  SIDEBAR: sidebar,
  USER: user
};

export default ACTIONS;